export const clearSavedFiltersForThisSession = ({ storageKey }: { storageKey: string }) => {
  if (!storageKey) return;

  sessionStorage.removeItem(storageKey);
};

export function getSavedFiltersForThisSession<T>({ storageKey }: { storageKey: string }) {
  try {
    return sessionStorage.getItem(storageKey) && (JSON.parse(sessionStorage.getItem(storageKey)) as T);
  } catch (err) {
    // Nom nom (return undefined)
    return undefined;
  }
}

export const saveFiltersForThisSession = ({ storageKey, filters }: { storageKey: string; filters: any }) => {
  if (!storageKey) return;

  sessionStorage.setItem(storageKey, JSON.stringify(filters));
};
